<template>
  <Modal v-model="isShow" width="65%" :closable="false" :mask-closable="false">
    <div slot="header" class="info-header">
      <div class="ivu-modal-header-inner">客户信息</div>
      <a class="ivu-modal-close" @click="closeModel"><i class="ivu-icon ivu-icon-ios-close"></i></a>
    </div>
    <div>
      <Form ref="custominfoForm" :model="form" :label-width="80" :rules="ruleValidate">
        <Row>
          <Col span="12">
            <FormItem label="公司名称" prop="customId">
              <Input v-model="form.customId" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="统一社会信用代码" prop="tradeNo">
              <Input v-model="form.tradeNo" :disabled="disable"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Upload ref="upd" action="/api/paas/file/upload" :on-success="handleUploadSuccess" :on-remove="handleRemove"
                  accept=".pdf">
            <Button icon="ios-cloud-upload-outline">上传文件</Button>
          </Upload>
        </Row>
      </Form>
    </div>
    <div slot="footer">
      <Button @click="closeModel">取消</Button>
      <Button type="primary" @click="submit" v-show="!canSubmit">提交</Button>
    </div>
  </Modal>
</template>

<script>

export default {
  name: 'upload-bill',
  data () {
    return {
      form: {},
      isShow: false,
      type: 'add',
      disable: true,
      showRemoveFile: false,
      canSubmit: true,
      file: null,
      multi: [],
      ruleValidate: {
        customId: [
          { required: true, message: '公司名称不允许为空', trigger: 'blur' }
        ],
        tradeNo: [
          { required: true, message: '统一社会信用代码不允许为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    openModel (type, data) {
      this.isShow = true
      this.type = type
      if (data) {
        this.form = data
      } else {
        this.form = {}
      }
      this.canSubmit = true
      this.disable = type === 'detail'
      this.multi = []
      this.$refs.upd.clearFiles()
    },
    closeModel () {
      this.isShow = false
    },
    initUpload () {
      this.file = null
      this.showProgress = false
      this.$refs.upd.clearFiles()
    },
    handleUploadFile () {
      this.initUpload()
    },
    handleUploadSuccess (response, file, fileList) {
      this.form.bankCardNo = response.data

      let upload = {
        customId: this.form.customId,
        tradeNo: this.form.tradeNo,
        bankCardNo: this.form.bankCardNo
      }

      this.multi.push(upload)

      this.canSubmit = false
      this.showRemoveFile = true
    },
    handleRemove (file, fileList) {
      // this.initUpload()
      // console.log('file:' + JSON.stringify(file))
      this.multi = this.multi.filter(e => e.bankCardNo !== file.response.data)

      this.$Message.info('上传的文件已删除！')
    },
    handleBeforeUpload (file) {
      const fileExt = file.name.split('.').pop().toLocaleLowerCase()
      if (fileExt === 'xlsx' || fileExt === 'xls') {
        this.readFile(file)
        this.file = file
      } else {
        this.$Notice.warning({
          title: '文件类型错误',
          desc: '文件：' + file.name + '不是EXCEL文件，请选择后缀为.xlsx或者.xls的EXCEL文件。'
        })
      }
      return false
    },
    submit () {
      this.showProgress = true
      this.disable = true
      for (let i = 0; i < this.multi.length; i++) {
        this.multi[i].customId = this.form.customId
        this.multi[i].tradeNo = this.form.tradeNo
      }
      this.$refs.custominfoForm.validate((valid) => {
        if (valid) {
          this.P('tradeuploadltd/multiCreate', this.multi).then(data => {
            this.$emit('handle-search')
            this.isShow = false
          })
        } else {
          this.$Message.error('请检查填写的数据')
          this.disable = false
        }
      })
    }
  },
  mounted: function () {
  }
}
</script>
